import { takeLatest, put, call, fork, select } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as actionTypes from '../constants';
import { getTicketStatus } from '../form/ticket-form-actions';

import {
  createSmartActionSuccess,
  createSmartActionFailure,
  saveSmartActionSuccess,
  saveSmartActionFailure,
  deleteSmartActionSuccess,
  deleteSmartActionFailure,
  fetchSmartActionSuccess,
  fetchSmartActionFailure,
} from './smart-action-sidepanel-actions';

export const getUser = state => state.user.id;

export function* doCreateSmartAction(action) {
  try {
    const {
      payload: {
        creatingOrder,
        ticketId,
        actionType,
        description,
        originalNote,
        note,
        scope,
        type,
        reminder,
        followUpBy,
        followUpByDisplayName,
        followUpByMail,
        manager,
        managerDisplayName,
        managerMail,
        since,
        operations,
        parts,
      },
    } = action;

    const changerId = yield select(getUser);

    const data = {
      ticketId,
      actionType,
      description,
      originalNote,
      note,
      scope,
      changerId,
      customerDownType: type,
      reminder,
      followUpBy,
      followUpByDisplayName,
      manager,
      managerDisplayName,
      since,
      followUpByMail,
      managerMail,
      operations,
      parts,
    };

    const results = yield call(callApi, {
      endpoint: 'ticket/action/new',
      options: {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
        errorMessage: 'Could not add/update smart action',
        retryAction: action,
      },
    });
    yield put(createSmartActionSuccess({ ...results, creatingOrder }));
    yield put(getTicketStatus({ id: ticketId }));
  } catch (err) {
    yield put(createSmartActionFailure(err));
  }
}

export function* doSaveSmartAction(action) {
  try {
    const { payload } = action;

    const changerId = yield select(getUser);
    const data = {
      id: payload.id,
      description: payload.description,
      originalNote: payload.originalNote,
      note: payload.note,
      scope: payload.scope,
      changerId,
      customerDownType: payload.type,
      reminder: payload.reminder,
      followUpBy: payload.followUpBy,
      followUpByDisplayName: payload.followUpByDisplayName,
      manager: payload.manager,
      managerDisplayName: payload.managerDisplayName,
      since: payload.since,
      followUpByMail: payload.followUpByMail,
      managerMail: payload.managerMail,
      operations: payload.operations,
      parts: payload.parts?.map(p => ({
        materialNumber: p?.materialNumber,
        vendorId: p?.vendorId,
        quantity: p?.quantity,
        addToOrder: p?.addToOrder,
      })),
    };

    const results = yield call(callApi, {
      endpoint: 'ticket/action/save',
      options: {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
        errorMessage: 'Could not add/update smart action',
        retryAction: action,
      },
    });
    if (payload.cb) {
      payload.cb();
    }
    yield put(saveSmartActionSuccess({ ...results, creatingOrder: payload.creatingOrder }));
    yield put(getTicketStatus({ id: payload.ticketId }));
  } catch (err) {
    yield put(saveSmartActionFailure(err));
  }
}

export function* doDeleteSmartAction(action) {
  try {
    const { payload } = action;

    const changerId = yield select(getUser);

    const data = {
      ticketId: payload.action.ticketId,
      ticketActionId: payload.action.id,
      reason: action.payload.reason,
      deletedById: changerId,
    };

    const results = yield call(callApi, {
      endpoint: 'ticket/action/delete',
      options: {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
        errorMessage: 'Could not delete smart action',
        retryAction: action,
      },
    });
    yield put(deleteSmartActionSuccess(results));
    yield put(getTicketStatus({ id: payload.action.ticketId }));
  } catch (err) {
    yield put(deleteSmartActionFailure(err));
  }
}

export function* doFetchSmartAction(action) {
  try {
    const results = yield call(callApi, {
      endpoint: `ticket/action/${action.payload}`,
      options: {
        errorMessage: 'Could not fetch smart action',
        retryAction: action,
      },
    });
    yield put(fetchSmartActionSuccess(results));
  } catch (err) {
    yield put(fetchSmartActionFailure(err));
  }
}

function* watchCreateSmartAction() {
  yield takeLatest(actionTypes.CREATE_SMART_ACTION, doCreateSmartAction);
}

function* watchSaveSmartAction() {
  yield takeLatest(actionTypes.SAVE_SMART_ACTION, doSaveSmartAction);
}

function* watchDeleteSmartAction() {
  yield takeLatest(actionTypes.DELETE_SMART_ACTION, doDeleteSmartAction);
}

function* watchFetchSmartAction() {
  yield takeLatest(actionTypes.FETCH_SMART_ACTION, doFetchSmartAction);
}

export default [
  fork(watchCreateSmartAction),
  fork(watchSaveSmartAction),
  fork(watchDeleteSmartAction),
  fork(watchFetchSmartAction),
];
